<template>
    <div id="testimonials" class="section">
        <v-container>
            <h2>Testimonials</h2>
            <hr>
            <p class="text-xs-center mb-5">Maria's Testimonials</p>   

          <v-layout wrap row>
            <v-flex xxs12 sm4 v-for="(testy, index) in testimonials" :key="index" class="pa-1">
                <v-card dark>
                    <v-card-text>
                      <blockquote>
                        <div v-html="testy.text"></div>
                        <footer><cite class="author">- {{testy.author}}</cite></footer>
                      </blockquote>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>


        </v-container>
    </div>
</template>

<script>
    export default {
      name: 'Testimonials',
        data: () => ({
          testimonials: [
              {
                text: '<p>Maria Danishvar Brown is an extremely accomplished and polished performer. Her beautiful voice, large and true, is even throughout its considerable range. Perhaps at her most comfortable and impressive in romantic opera and Russian song, she has also studied a large amount of early baroque material. Here her performances are historically informed without ever being precious. The volume may be scaled down to suit the accompanying instruments, but never the emotional intensity.</p>',
                author: 'George Hubbuck, bass-baritone'
              },
              {
                text: '<p>The heartfelt passion and power that Maria/Masha brings with good effect to her luscious performances of early Baroque repertoire as an invaluable member of Musicke in the Ayre owe much to her mastery of the mainstream classical repertoire, and of Russian art song in particular.</p>',
                author: 'Din Ghani, Lutenist (Musicke in the Ayre)'
              },
              {
                text: '<p>The quality of her voice – at the same time rich and full of colour, as well as subtle and delicate – comes through her assured delivery. Her singing is never forced, always natural – as if she is basking in the sheer joy of the music. When she sings, one feels it is for you alone she is singing – so immediate is her presence – whether she is in a small living room or a large concert hall. She takes each listener into her embrace and holds them there – totally enthralled.</p>',
                author: 'Lillian Delevoryas, artist, designer.'
              },
              {
                text: '<p>Maria deeply senses the profound meaning of music of all periods and styles generously sharing her understanding with audience.</p>',
                author: 'Liudmilla Bezpaltchaya, pianist'
              }                                                                                
            ]
        })
      }
</script>

<style>
  #testimonials {
    margin-top: 40px;
  }
  #testimonials .author {
    font-size: 13px!important;
  }
</style>

